import { ApiBase } from '@bymason/api-base';

class ContactForm extends ApiBase {
  private static instance: ContactForm;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns A ContactForm instance
   */
  public static getInstance(): ContactForm {
    if (!ContactForm.instance) {
      ContactForm.instance = new ContactForm();
    }

    return ContactForm.instance;
  }

  /**
   * Submit contact information.
   * @param clientToken token required for proper authorization.
   * @param data contact form data
   * @returns void
   */
  public async submit(data: Record<string, string>, clientToken: string) {
    const url = 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8';
    const normData = { ...data, orgid: '00D2E0000013HcL' };
    const body = new URLSearchParams(normData).toString();

    const dataResponse = await this.callFormEndpoint({
      body,
      clientToken,
      encodingType: 'url',
      method: 'POST',
      mode: 'no-cors',
      url,
    });

    return dataResponse;
  }
}

export const contactFormClient = ContactForm.getInstance();
